<template>
    <a :href="website" class="btn btn-info text-white me-2" target="_blank">Details</a>
</template>


<script>
    import axios from 'axios';
    export default {
        props: {
            data: null,
        },
        data() {
            return {
                detail: null
            };
        },
        computed: {
            website() {
                return this.detail ? this.detail.invoice_url : 'Loading...';
            }
        },
        created() {
            this.fetchInvoiceDetail();
        },
        methods: {
            fetchInvoiceDetail() {
                if(this.data != undefined){
                    axios.get('/api/zoho/invoice/' + this.data)
                    .then(response => {
                        let data = response.data.invoice;
                        this.detail = data;
                    })
                    .catch(() => {
                        this.error = 'Not found';
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                }
                
            }
        },
    };

</script>

